import React from "react";

import { Form, Input, Radio } from "antd";
import FormOrderCard from "../../Order/components/OrderCard/OrderCreateAndEdit";

const { Item } = Form;
const { Group, Button } = Radio;

const OfferDocuments = props => {
  const { disabled, parent, typeForm, form, noFreightOrder } = props;
  const { getFieldDecorator, getFieldValue } = form;
  const responsibleDocumentsList = getFieldValue("responsibleDocumentsList");
  const serviceType = getFieldValue("serviceType");
  return (
    <>
      <div className="offer-card__item">
        <span className="offer-card__title-center">
          Ответственные лица за подготовку документов
        </span>
      </div>
      <Item hidden={true}>
        {getFieldDecorator("responsibleDocumentsKeyList")(<Input disabled />)}
      </Item>
      <Item hidden={true}>
        {getFieldDecorator("noFreightOrder", {
          initialValue: noFreightOrder
        })(<Input disabled />)}
      </Item>
      <div>
        {/*Кароч если это карточка просмотра заказа, то мы должны отобразить значения как Input.
        Далее если это не просмотр карточки заказа, а просмотр карточки предложения то отрендериить это как группу Button.
        Ну а если это создание заказа и предложения, то рендерить уже всё на основе serviceType*/}
        {parent === "order" && typeForm === "view"
          ? responsibleDocumentsList && responsibleDocumentsList.length > 0
            ? responsibleDocumentsList.map(document => {
                return (
                  <div
                    key={document.documentTypeName}
                    className="offer-card__item"
                  >
                    <span className="label">{document.documentTypeName}:</span>
                    <Item>
                      <Input
                        value={
                          document.isClient === 1 ? "Заказчик" : "Исполнитель"
                        }
                        disabled
                      />
                    </Item>
                  </div>
                );
              })
            : null
          : responsibleDocumentsList && responsibleDocumentsList.length > 0
          ? responsibleDocumentsList.map(document => {
              return (
                <div
                  key={document.documentTypeName}
                  className="offer-card__item"
                >
                  <span className="label">{document.documentTypeName}:</span>
                  <Item>
                    {getFieldDecorator(document.documentTypeKey)(
                      <Group
                        size="medium"
                        disabled={
                          disabled ||
                          // Данный список документо всегда предоставляется исполнителей, т.е. перевозчиком
                          document.documentTypeKey === "cc" ||
                          document.documentTypeKey === "wo" ||
                          document.documentTypeKey === "receipt" ||
                          document.documentTypeKey === "waybill" ||
                          document.documentTypeKey === "ra" ||
                          document.documentTypeKey === "ordrep" ||
                          document.documentTypeKey === "di" ||
                          document.documentTypeKey === "rp" ||
                          document.documentTypeKey === "gn" ||
                          document.documentTypeKey === "bill" ||
                          document.documentTypeKey === "gi"
                        }
                      >
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
              );
            })
          : serviceType
          ? (serviceType === "simple" && (
              <>
                <div className="offer-card__item">
                  <span className="label">Список пассажиров:</span>
                  <Item>
                    {getFieldDecorator("plist", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={false}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                {!noFreightOrder && (
                  <div className="offer-card__item double-margin">
                    <span className="label">Договор фрахтования:</span>
                    <Item>
                      {getFieldDecorator("cc", {
                        initialValue: false
                      })(
                        <Group size="medium" disabled={true}>
                          <Button value={true}>Заказчик</Button>
                          <Button value={false}>Исполнитель</Button>
                        </Group>
                      )}
                    </Item>
                  </div>
                )}
                <div className="offer-card__item">
                  <span className="label">Заказ-наряд:</span>
                  <Item>
                    {getFieldDecorator("wo", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={true}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">Квитанция:</span>
                  <Item>
                    {getFieldDecorator("receipt", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={true}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">Путевой лист:</span>
                  <Item>
                    {getFieldDecorator("waybill", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={true}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">Акт об оказании услуг:</span>
                  <Item>
                    {getFieldDecorator("ra", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={true}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">Отчет по заказу:</span>
                  <Item>
                    {getFieldDecorator("ordrep", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={true}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
              </>
            )) ||
            (serviceType === "kids" && (
              <>
                <div className="offer-card__item">
                  <span className="label">Список детей:</span>
                  <Item>
                    {getFieldDecorator("clist", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={false}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">Список сопровождающих:</span>
                  <Item>
                    {getFieldDecorator("alist", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={false}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">
                    Список работников и (или) физ. лиц, уч. в ОПГД:
                  </span>
                  <Item>
                    {getFieldDecorator("workphys", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={false}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">Список продуктов питания:</span>
                  <Item>
                    {getFieldDecorator("fplist", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={false}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">
                    Список мест размещения детей на отдых в ночное время:
                  </span>
                  <Item>
                    {getFieldDecorator("kidsnight", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={false}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">
                    Список посадки/высадки пассажиров в промежуточных пунктах:
                  </span>
                  <Item>
                    {getFieldDecorator("arrland", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={false}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">Сведения о медработниках:</span>
                  <Item>
                    {getFieldDecorator("hwi", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={false}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item double-margin">
                  <span className="label">Сведения о водителях:</span>
                  <Item>
                    {getFieldDecorator("di", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={true}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">Маршрут перевозки:</span>
                  <Item>
                    {getFieldDecorator("rp", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={true}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">Уведомление в ГИБДД:</span>
                  <Item>
                    {getFieldDecorator("gn", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={true}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">
                    Идентификатор уведомления в ГИБДД:
                  </span>
                  <Item>
                    {getFieldDecorator("gi", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={true}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                {!noFreightOrder && (
                  <div className="offer-card__item">
                    <span className="label">Договор фрахтования:</span>
                    <Item>
                      {getFieldDecorator("cc", {
                        initialValue: false
                      })(
                        <Group size="medium" disabled={true}>
                          <Button value={true}>Заказчик</Button>
                          <Button value={false}>Исполнитель</Button>
                        </Group>
                      )}
                    </Item>
                  </div>
                )}
                <div className="offer-card__item">
                  <span className="label">Заказ-наряд:</span>
                  <Item>
                    {getFieldDecorator("wo", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={true}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">Путевой лист:</span>
                  <Item>
                    {getFieldDecorator("waybill", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={true}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">Квитанция:</span>
                  <Item>
                    {getFieldDecorator("receipt", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={true}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">Акт об оказании услуг:</span>
                  <Item>
                    {getFieldDecorator("ra", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={true}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">Отчет по заказу:</span>
                  <Item>
                    {getFieldDecorator("ordrep", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={true}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
              </>
            )) ||
            (serviceType === "undefined" && (
              <>
                {!noFreightOrder && (
                  <div className="offer-card__item">
                    <span className="label">Договор фрахтования:</span>
                    <Item>
                      {getFieldDecorator("cc", {
                        initialValue: false
                      })(
                        <Group size="medium" disabled={true}>
                          <Button value={true}>Заказчик</Button>
                          <Button value={false}>Исполнитель</Button>
                        </Group>
                      )}
                    </Item>
                  </div>
                )}
                <div className="offer-card__item">
                  <span className="label">Заказ-наряд:</span>
                  <Item>
                    {getFieldDecorator("wo", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={true}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">Путевой лист:</span>
                  <Item>
                    {getFieldDecorator("waybill", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={true}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">Квитанция:</span>
                  <Item>
                    {getFieldDecorator("receipt", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={true}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">Акт об оказании услуг:</span>
                  <Item>
                    {getFieldDecorator("ra", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={true}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">Отчет по заказу:</span>
                  <Item>
                    {getFieldDecorator("ordrep", {
                      initialValue: false
                    })(
                      <Group size="medium" disabled={true}>
                        <Button value={true}>Заказчик</Button>
                        <Button value={false}>Исполнитель</Button>
                      </Group>
                    )}
                  </Item>
                </div>
              </>
            ))
          : null}
      </div>
    </>
  );
};

export default OfferDocuments;
